module.exports = __webpack_public_path__ + "static/media/shuangqian2.dc8de3e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/medals/shuangqian2.png
// module id = 575
// module chunks = 6